import React from 'react'

const Card = ({ title, id, className = '', children }) => {
    return (
        <div className={`relative mx-6 md:mx-44 my-6 md:my-20 flex flex-col opacity-0 -translate-x-40 transition duration-500 js-show-on-scroll ${className}`} id={id}>
            <h2 className="text-center text-transparent bg-clip-text bg-gradient-to-r from-green-400 via-blue-400 to-purple-400 text-3xl md:text-4xl font-bold tracking-tight self-center mb-8">{title}</h2>
            <div className="bg-zinc-800/30 backdrop-blur-sm rounded-2xl p-6 md:p-8 border border-zinc-700/50 shadow-xl">
                {children}
            </div>
        </div>
    )
}

export default Card